import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { webClientFileDownload } from '../../core/web_client';
import { ARRANGEMENT_PATH } from '../../core/constants';
import { buildQueryString, exportFile, extractErrorDataFromFile, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const generateArrangementAction = createAsyncThunk(
    'reservation/generateArrangementAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClientFileDownload.post(`${ ARRANGEMENT_PATH }/generate${ buildQueryString(queryParams) }`);
            const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replaceAll('"', '');
            exportFile(extractResponseData(response), fileName ? fileName : 'zamowienia.pdf');
            return fulfillWithValue();
        } catch (error) {
            const response = await extractErrorDataFromFile(extractResponseData(error?.response));
            return rejectWithValue(response);
        }
    }
);

const generateArrangementSlice = createSlice({
    name: 'generateArrangementSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(generateArrangementAction.pending, () => STATE__API__STARTED);
        builder.addCase(generateArrangementAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(generateArrangementAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const generateArrangementState = (state) => state.reservation.generateArrangement;
export default generateArrangementSlice.reducer;
